import {config, http} from './__http';
import qs from 'qs';

export default {
    // ACCOUNT
    userLogin(user, creds) {
        http.post(window.app.config.tokenUrl, qs.stringify(creds)).then(response => {
            http.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    impersonateUser(user, customer) {
        http.post(config.baseUrl(true)+'Account/Impersonate?customerKey='+customer).then(response => {
            http.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.AccessToken;
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    revertImpersonate(user) {
        http.post(config.baseUrl(true)+'Account/RevertImpersonate').then(response => {
            http.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.AccessToken;
            user(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    disableCustomerIsWatching(user, params) {
        http.post(config.baseUrl(true)+'Account/DisableCustomerIsWatching', params).then(response => {
            user(response);
        }).catch(e => {
            console.error(e);
        });
    },
    register(user, params){
        http.post(config.baseUrl(true)+'Account/Register?userId='+params.userId, params.body).then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    confirmEmail(user, params){
        http.get(config.baseUrl(true)+'Account/ConfirmEmail?userId='+params.userId+'&code='+encodeURIComponent(params.code)).then(response => {
            user(response.data);
        }).catch(e => {
            console.error(e);
        });
    },
    getUser(user){
        http.get(config.baseUrl(true)+'Account').then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    getUserById(user, id) {
        http.get(config.baseUrl(true) + 'account/' + id).then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        })
    },

    sendUser(user, params){
        http.put(config.baseUrl(true)+'Account', params).then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    changePassword(user, params){
        http.post(config.baseUrl(true)+'Account/ChangePassword', params).then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    forgotPassword(user, params){
        http.post(config.baseUrl(true)+'Account/ForgotPassword', params).then(response => {
            user(response);
        }).catch(e => {
            user(e.response);
        });
    },
    resetPassword(user, params){
        http.post(config.baseUrl(true)+'Account/ResetPassword', params).then(response => {
            user(response.data);
        }).catch(e => {
            user(e.response);
        });
    },
    getEmployees(employee) {
        http.get(config.baseUrl(true) + 'Account/employees').then(response => {
            employee(response.data)
        }).catch(e => {
            employee(e.response);
        });
    },
    searchUsers(users, params){
        http.get(config.baseUrl(true) + 'Account/search?customerKey=' + params.customerKey + '&keyword=' + params.keyword).then(response => {
            users(response.data);
        }).catch(e => {
            console.error(e);
        })
    },

    // CUSTOMER
    getCustomerOrders(orders, params){
        http.get(config.baseUrl()+'/Customer/Orderhistory').then(response => {
            orders(response.data)
        }).catch(e => {
            orders(e.response)
        });
    },
    getCustomerBackOrders(backorders, params){
        http.get(config.baseUrl()+'/Customer/Backorder').then(response => {
            backorders(response.data)
        }).catch(e => {
            backorders(e.response)
        });
    },
    getCustomerInvoices(invoices, params){
      http.get(config.baseUrl()+'/Customer/Invoice',{ params }).then(response => {
        invoices(response.data)
      }).catch(e => {
        invoices(e.response)
      });
    },
    editCustomerKey(customer, params){
        http.put(config.baseUrl()+'/Customer/CustomerKey', params).then(response => {
            customer(response.data)
        }).catch(e => {
            customer(e.response);
        })
    },

    // ADDRESSES
    sendAddress(address, params){
        http.post(config.baseUrl()+'/Customer/'+params.customer+'/Address', params.body).then(response => {
            address(response.data);
        }).catch(e => {
            address(e.response);
        });
    },
    deleteAddress(address, params){
        http.post(config.baseUrl()+'/Customer/'+params.customer+'/DeleteAddress', params.body).then(response => {
            address(response.data);
        }).catch(e => {
            address(e.response);
        });
    },

    getDeliveryAddress(address, customer){
        http.get(config.baseUrl()+'/Customer/'+customer+'/DeliveryAddress').then(response => {
            address(response.data)
        }).catch(e => {
            address(e.response)
        });
    },
    getInvoiceAddress(address, customer){
        http.get(config.baseUrl()+'/Customer/'+customer+'/InvoiceAddress').then(response => {
            address(response.data)
        }).catch(e => {
            address(e.response)
        });
    },
    getShopAddress(address, customer){
        http.get(config.baseUrl()+'/Customer/'+customer+'/ShopAddress').then(response => {
            address(response.data)
        }).catch(e => {
            address(e.response)
        });
    },
    getDealerLocatorAddress(address, customer){
        http.get(config.baseUrl()+'/Customer/'+customer+'/DealerLocator').then(response => {
            address(response.data)
        }).catch(e => {
            address(e.response)
        });
    },
    showOnDealerLocator(address, params){
        http.post(config.baseUrl()+'/Customer/DealerLocator/'+params.Id+'/Show',params).then(response => {
            address(response.data)
        }).catch(e => {
            console.error(e);
        })
    },
    hideOnDealerLocator(address, id){
        http.post(config.baseUrl()+'/Customer/DealerLocator/'+id+'/Hide').then(response => {
            address(response.data)
        }).catch(e => {
            console.error(e);
        })
    },


    // ORDER
    getHistoryOrderDetail(order, params){
        http.get(config.baseUrl()+'/Order/' + params.id).then(response => {
            order(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    downloadImages(order, id) {
        http.get(config.baseUrl()+'/Order/'+id+'/images').then(response => {
            order(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    downloadOrderLinesCsv(order, id) {
        http.get(config.baseUrl()+'/Order/'+id+'/csv').then(response => {
            order(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    downloadSheet(pdf, id) {
        http.get(config.baseUrl()+'/ProductGroup/'+id+'/productsheet').then(response => {
            pdf(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    reOrder(callback, params){
        http.post(config.baseUrl() + '/order/' + params.id + '/reorder', params.body).then(response =>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },
    requestInvoice(callback, id){
        http.post(config.baseUrl() + '/order/' + id + '/invoice').then(response =>{
            callback(response.data);
        }).catch(e =>{
            callback(e.response);
        });
    },
    deleteUser(callback, email) {
        http.post(config.baseUrl(true) + 'account/remove', email).then(response => {
            callback(response.data);
        }).catch(e => {
            callback(e.response);
        });
    },

    // WARRANTY
    requestWarranty(request, params){
        http.post(config.baseUrl()+'/warranty', params).then(response => {
            request(response.data)
        }).catch(e => {
            request(e.response)
        });
    },

    // CUSTOMER IS WATCHING
    customerIsWatching(request){
        http.post(config.baseUrl(true)+'/account/customeriswatching').then(response => {
            request(response.data)
        }).catch(e => {
            console.error(e.response);
        });
    },

    // CONTACT FORM
    sendContactForm(request, params){
        http.post(config.baseUrl()+'/customer/contact', params).then(response => {
            request(response.data)
        }).catch(e => {
            request(e.response)
        });
    },

    // PREORDERSHEET REPORT
    getSalesmen(request, search){
        http.get(config.baseUrl(true)+'account/salesmanAutocomplete?search=' + search).then(response => {
            request(response.data)
        }).catch(e => {
            request(e.response)
        });
    }

}



// WEBPACK FOOTER //
// ./src/api/Account.js